<template>
  <div>
    <RegistrationLayoutTitles
      :title="$t('registration.rewards.title')"
      :subTitle="$t('registration.rewards.automatic_rewards')"
    />
    <div class="md:w-435 md:mx-auto">
      <GiftCardSelector
        v-for="(reward, idx) in groupedAutoRewards"
        :key="idx"
        :reward="reward"
        :autoReward="true"
      />
      <RewardAddressSelector class="my-30" :autoReward="true" />
      <HMButton
        id="finishButton"
        class="w-full tracking-wide"
        :disabled="!selectedAutoReward.id"
        rounded="full"
        fontWeight="semibold"
        @click="handleFinish"
      >
        {{ $t('common.finish_btn') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import RegistrationLayoutTitles from '@components/layouts/RegistrationLayoutTitles'
import GiftCardSelector from '@components/views/rewards/GiftCardSelector.vue'
import RewardAddressSelector from '@components/views/rewards/RewardAddressSelector.vue'
import getTime from 'date-fns/getTime'

export default {
  components: {
    RegistrationLayoutTitles,
    GiftCardSelector,
    RewardAddressSelector,
  },
  computed: {
    ...mapGetters('registration', ['registrationAddress', 'availableProducts']),
    ...mapGetters('rewards', [
      'selectedAutoReward',
      'groupedAutoRewards',
      'autoRewardDeliveryAddress',
    ]),
    ...mapGetters('questionnaire', ['startUpQuestionnaire']),
    ...mapGetters('member', ['showPhaWelcome']),
    ...mapGetters('app', ['postLoginPath']),
    formInvalid() {
      return this.$v.$invalid
    },
  },
  mounted() {
    this.initRewards()
  },
  methods: {
    ...mapActions('registration', [
      'getAvailableProducts',
      'saveRewardAddress',
      'resetState',
    ]),
    ...mapActions('rewards', ['setupAutoReward', 'initRewards']),
    ...mapActions('app', ['removePostLoginPath']),
    handleFinish() {
      const rewardAddress = this.autoRewardDeliveryAddress
        ? this.autoRewardDeliveryAddress
        : this.registrationAddress

      const { productId, type: delivery } = this.selectedAutoReward
      this.setupAutoReward({
        productId,
        delivery,
        address: rewardAddress,
      })
        .then(() => {
          this.resetState()

          if (this.postLoginPath) {
            this.$router
              .replace(this.postLoginPath)
              .then(this.removePostLoginPath)
          } else if (this.startUpQuestionnaire && !this.showPhaWelcome) {
            localStorage.setItem('fteViewTime', getTime(new Date()))
            this.$router.push(
              `/questionnaire/${this.startUpQuestionnaire.type}`
            )
          } else {
            this.$router.replace('/')
          }
        })
        .catch((error) => {
          this.error = error.message
        })
    },
  },
}
</script>
